/**
 * [MCV-1957] Employer signup has no approval step yet: nothing reaches the server until the
 * registration is created, and no one is ever asked to approve it. In prod, submitting the
 * facility step creates the employer straight away and the "Bypass Approval (Dev Only)" button
 * is never shown. Dev, staging and local builds keep the pending screen and its button.
 *
 * Keyed on VITE_ENVIRONMENT, not import.meta.env.PROD: every deployed environment is a
 * production build, so PROD cannot tell prod from staging.
 */
export const employerSignupSkipsApproval = (): boolean =>
  import.meta.env.VITE_ENVIRONMENT === 'prod';
